<div class="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
  <p-selectButton [options]="[{value: 'en', label: 'EN 🇬🇧'}, {value: 'de', label: 'DE 🇩🇪'}]" (onChange)="onChangeLocale($event)" [ngModel]="locale" optionLabel="label" optionValue="value" styleClass="px-2 py-1">
  </p-selectButton>
</div>
